/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['ن', 'ظ', 'ص', 'ب.ظ.', 'ع', 'ش'],
    ['نیمه\u200cشب', 'ظهر', 'صبح', 'ب.ظ.', 'عصر', 'شب'],
    ['نیمه\u200cشب', 'ظهر', 'صبح', 'بعدازظهر', 'عصر', 'شب']
  ],
  [
    ['ن', 'ظ', 'ص', 'ب.ظ.', 'ع', 'ش'],
    ['نیمه\u200cشب', 'ظهر', 'صبح', 'بعدازظهر', 'عصر', 'شب'],
  ],
  [
    '00:00', '12:00', ['04:00', '12:00'], ['12:00', '17:00'], ['17:00', '19:00'],
    ['19:00', '04:00']
  ]
];
